import { useDecision } from '@optimizely/react-sdk'

export function useIsCheckoutBoxTangibilityV3Enabled() {
  const [boxTangibilityDecision] = useDecision('beetroots_ofx_checkout_box_tangibility_v3')

  return boxTangibilityDecision.variationKey === 't1'
}
